import contract from '@mailobj-browser/front/js/contracts/contract.js'
import mains from './mains/mains.js'

export default contract({
    mains
})